import React, { useState, useRef, useEffect, useCallback } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Helmet from "react-helmet";
import { defaultTitle, tokenKeyName, basePath } from "../../config";
import InvoiceCard from "../InvoiceList/InvoiceCard";
import { Modal } from "react-bootstrap";
import jwtDecode from "jwt-decode";
import {
  getCitiesForState,
  getCityAndStates,
  getCustomerDefaultCODTypeSettings,
  getCustomersForAccountNumber,
  getCustomersForCityAndState,
  getTimeCodesForCityAndState,
  getTimeCodesForCityAndStateAndZip,
  getTop10CustomersForClient,
} from "../../services/customerService";
import handleApiError from "../../helpers/handleApiError";
import { BsArrowClockwise, BsInfoCircle } from "react-icons/bs";
import { generatePath, Link, useHistory, useParams } from "react-router-dom";
import debounce from "lodash/debounce";
import http from "../../services/httpService";
import { apiUrl, constants } from "../../config";
import * as constantsJS from "../../constants";
// import axios from "axios";
import { toast } from "react-toastify";
import { getDropShipInfos, isClient } from "../../services/accountService";
import { DiliTextCP } from "../Utility/DiliTextCP";
import {
  dateBeforeMidnightOfCreationDate,
  getTimeCodeMeaning,
  sortAccountLookupTimeCodes,
} from "../../helpers/utilities";
import { useMemo } from "react";
import {
  checkInvoiceAlreadyExists,
  getExistingOrder,
  getLabelsForMultipleDeliveries,
  getOrderDetailsOld,
  postOrder,
} from "../../services/deliveryService";
import { PiecesInput } from "./PiecesInput";
import fileDownload from "js-file-download";
import { GleamPanel } from "../Utility/GleamPanel";
import { codOptions } from "../../constants";
import { AutoInitiatePrint } from "../Utility/AutoInitiatePrint";
import { Combobox } from "../Utility/Combobox";
import { ComboboxInfiniteLoading } from "../Utility/ComboboxInfiniteLoading";
import { TooltipInfoHover } from "../Utility/TooltipInfoHover";
import { LabelViewerModal } from "../Utility/LabelViewerModal";
// import { canModify } from "../../helpers/orderActionsUtilities";

const generateCustomerDropdownDisplay = (customer, detailed) => {
  //customer should be an object with fields customerName and customerAddress
  //detailed should be true or false. If true, customer should also contain the fields
  //customerCity, customerState, route,
  return detailed
    ? `${customer.customerName.trim()} - ${customer.customerAddress.trim()} ${customer.customerCity.trim()}, ${customer.customerState.trim()} - ${customer.route.substring(
        customer.route.length - 2,
        customer.route.length,
      )}`
    : customer.customerName?.trim() + " - " + customer.customerAddress.trim();
};
//CONSTANTS=========================================================================
const maxInvoices = constants.CreatingOrder.maxInvoices;
// const customerSelectionTypes = {
//   existing: "existing",
//   account: "account",
//   new: "new",
// };
const customerSelectionTypes = constantsJS.customerSelectionTypes;

const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

//==================================================================================

//TEMPLATES=========================================================================================
//IF YOU USE THESE, DO NOT PASS THEM IN DIRECTLY, SPREAD IT INTO A NEW OBJECT: e.g. {...InvoiceTemplate}
//OTHERWISE IT WILL REFERENCE THE ORIGINAL OBJECTS OR SOMETHING AND CAUSE BIZARRE BEHAVIOR
const InvoiceTemplate = {
  invoiceNumber: "",
  wantsValuationCoverage: false,
  invoiceAmount: "",
  alreadyExistsInSystem: false,
  // wasFormSubmitted:"" //this is so we can keep track if the form had been submitted WHILE this invoice was on the page. Or else once you try to submit =
};

//Mini Components - maybe move to their own files?
const NewOrderCustomerDisplay = ({
  name,
  address,
  city,
  state,
  zip,
  email,
  phone,
}) => {
  return (
    <address
      className="text-left m-md-auto p-2"
      style={{ width: "fit-content" }}
    >
      <h4>{name}</h4>
      <p className="m-1">{address}</p>
      <p className="m-1">{city + ", " + state + " " + zip}</p>
      {/* don't get it from the back end right now but added it anyway. */}
      {phone && <p className="m-1">{phone}</p>}
      {/* Do not get these from backend right now, not even sure we really store it */}
      {/* <p className="m-1">
    {email} 
  </p>
  <p className="m-1">
    {phone}
  </p> */}
    </address>
  );
};

const DuplicateInvoiceWarningModal = ({
  showDuplicateInvoiceWarningModal,
  onHideDuplicateInvoiceWarningModal,
  invoices,
  handleSubmitAsNormal,
  resetEverything,
  isModifyingExistingOrder,
}) => {
  const invoicesThatAlreadyExistInTheSystem = invoices
    .filter((invoice) => invoice.alreadyExistsInSystem)
    .map((invoice) => invoice.invoiceNumber);
  // const invoiceText =
  //   invoicesThatAlreadyExistInTheSystem.length > 1 ? "invoices" : "invoice";

  const [showModifyInsteadModal, setShowModifyInsteadModal] = useState(false);
  const onNoClick = (e) => {
    onHideDuplicateInvoiceWarningModal();
    handleSubmitAsNormal(e); //this is handleSubmit with false passed in already for checkForDuplicateInvoice parameter
  };
  const onYesClick = () => {
    onHideDuplicateInvoiceWarningModal();
    setShowModifyInsteadModal(true);
  };
  const onOkayToModifyInsteadModal = () => {
    resetEverything();
    setShowModifyInsteadModal(false);
  };

  return (
    <>
      <Modal show={showDuplicateInvoiceWarningModal} bg="static">
        <Modal.Header>
          <Modal.Title>Duplicate Invoice(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          The following invoice(s) already exist:
          <div className="pt-1 pb-4">
            {invoicesThatAlreadyExistInTheSystem.map((invoice) => {
              return (
                <div
                  key={invoice}
                  className="order-history-invoice-chip duplicate-invoice-chip"
                >
                  {invoice}
                </div>
              );
            })}
          </div>
          {isModifyingExistingOrder
            ? "Are you sure you wish to go through with this modification, which will result in duplicate invoices?"
            : "Are you creating this order to modify existing details for those invoice(s)?"}
        </Modal.Body>
        {/* This will cancel the submission if modifying or cancel the submission and reset the page for posting a new order. We wanted to make it a little confusing, so they would actually read and think about it. */}
        <Modal.Footer>
          {isModifyingExistingOrder ? (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                onHideDuplicateInvoiceWarningModal();
              }}
            >
              Cancel
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onYesClick}
            >
              Yes
            </button>
          )}
          {/* This is the click that actually submits the order/modification, even if it would create a duplicate invoice. */}
          <button
            type="button"
            className={`btn ${
              isModifyingExistingOrder ? "btn-primary" : "btn-secondary"
            }`}
            onClick={onNoClick}
          >
            {isModifyingExistingOrder ? "Confirm" : "No, this is a new order."}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModifyInsteadModal} bg="static">
        <Modal.Header>
          <Modal.Title>Modify or Void Previous Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          For existing order modifications, please modify the existing invoices
          or void them first before re-entering them. <br /> <br />
          If you need further assistance, please contact us at{" "}
          {constantsJS.emails.opsEmail}.
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onOkayToModifyInsteadModal}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const viewStates = {
  success: "success",
  loading: "loading",
  nodata: "nodata",
  error: "error",
};

//MAIN COMPONENT START
/////////////////////////////////
///////////////////////////////////////
////////////////////////////////////////////
////////////////////////////////////////////
const PostOrderFormRework13CityDropdown = ({ setLoading, loading }) => {
  //Third party hooks
  const history = useHistory();
  //General Data
  const [clientJWTInfo, setClientJWTInfo] = useState({});
  const [viewState, setViewState] = useState(viewStates.loading);
  const [errorViewStateMessage, setErrorViewStateMessage] = useState(
    "There was an issue processing your request. Please try refreshing the page.",
  );
  //CHANGE PAGE BASED ON============================
  //-customer by weight
  //-customer by account
  //-dropship customer

  //Customer selection types
  //-Manual, enter in values for customer name, address, city, state, zip, and phone? (double check to see if the backend does anything with the phone)
  //-Select existing customer by city/state
  //-Select customer by entering in their account number (IF they are a customer by account) (will this work for cxt?)
  //

  //

  //Customer Selection Type ===================================================
  //Existing
  //New Customer
  //Account Lookup (if they are a customer by account, )
  const [customerSelectionType, setCustomerSelectionType] = useState(
    customerSelectionTypes.existing,
  ); //existing, new, account
  const handleChangeCustomerSelectionType = (e) => {
    setCustomerSelectionType(e.target.value);
    //reinitialize existing customer logic
    setCityAndState("");
    setCustomerIndex();
    //reinitialize account lookup logic
    setAccountNumberToLookup("");
    setFoundAccountCustomer(null);
    setShowAccountNotFoundHelperText(false);
    //reinitialize new customer logic;
    reinitializeNewCustomerInfo();
    setTimeCode("");
    setTimeCodes([]);
    setTimeCodesError(false);
  };
  //============================================================================
  //order info====================================================================
  const [orderInfo, setOrderInfo] = useState({
    CODType: "",
    //this was for when I made a global default cod setting in the client profile page, but not wwanted
    // localStorage.getItem("client-portal-defaultCodOption") ??
    // codOptions.None.value,
    referenceNumber: "",
    BOLNumber: "",
    pieceAmount: "",
    pieceType: "",
    weight: "",
    comments: "",
    isDefaultChecked: false,
  });
  // const [CODTypeLoading, setCODTypeLoading] = useState(false);
  const CODTypeLoadingRef = useRef(false); //CHANGING REF VALUES DOES NOT CAUSE RERENDER, MAKE SURE THERE IS ALWAYS A STATE VARIABLE UPDATE RIGHT AFTER THIS TO RERENDER, IF NEEDED MAKE A STATE VARIABLE (OR UNCOMMENT THE ONE RIGHT ABOVE) AND UPDATE IT TO THE SAME AS THIS WHEREVER YOU CHANGE THIS RIGHT AFTER TO MAKE SURE UI STAYS IN SYNC. For now, everywhere I call this I do do a state update right after.
  const handleChangeOrderInfo = (e) => {
    // console.log(e);
    //this is for inputs where we have a pattern, if what the user enters would make the input invalid, we don't update the state.
    //This may not be a perfect solution, if there are issues with not being able to type in certain characters or not being able to erase everything, may want to look here*******
    // if (e.target.validity.valid || e.target.value === "") {
    const { name, value, type, checked } = e.target;

    if (name === "pieceAmount") {
      setOrderInfo({
        ...orderInfo,
        [name]:
          value > constants.CreatingOrder.maxPieceCount //if value greater than maxpiececount set it to maxpiececount
            ? constants.CreatingOrder.maxPieceCount
            : value <= 0 //if value is 0 or less set it to "", with all the other logic, this basically just blocks them from entering just 0
              ? ""
              : value,
      });
    } else {
      // console.log("changed order info");
      // console.log("name: " + name + ", value: " + value);
      // console.log(orderInfo);
      if (name === "CODType") {
        //if user changes codtype before we get a default cod type from the server, set cod type loading to false
        //if cod type loading is false, we do not set the codtype to the response and the user's choice will not be overwritten.
        if (CODTypeLoadingRef.current) {
          CODTypeLoadingRef.current = false;
        }
      }
      setOrderInfo({
        ...orderInfo,
        [name]: type === "checkbox" ? checked : value, // if it's a checkbox, use the value of checked, if not use the value of value
      });
    }
    // }
  };

  //new/manual customer info
  const [newCustomerInfo, setNewCustomerInfo] = useState({
    customerName: "",
    customerAddress: "",
    customerCity: "",
    customerState: "",
    customerZip: "",
    customerPhone: "",
  });
  const [citiesForState, setCitiesForState] = useState([]);

  const reinitializeNewCustomerInfo = () => {
    setNewCustomerInfo({
      customerName: "",
      customerAddress: "",
      customerCity: "",
      customerState: "",
      customerZip: "",
      customerPhone: "",
    });
  };
  const handleChangeNewCustomerInfo = async (e) => {
    const { name, value } = e.target;

    if (name === "customerState") {
      setLoading(true);
      setNewCustomerInfo({
        ...newCustomerInfo,
        customerCity: "",
        [name]: value,
      });
      try {
        const citiesForStateResponse = await getCitiesForState(value);
        // console.log(citiesForStateResponse);
        const clientsCities = citiesForStateResponse.data.clientCity;

        //Previously had all cities we ship to displayed, with the ones the client did not have access to disabled and grayed out.
        // const allCities = citiesForStateResponse.data.allCity;

        // const cities = allCities.map((city, index) => {
        //   return {
        //     name: city,
        //     hasAccess: clientsCities.includes(city),
        //   };
        // });

        setCitiesForState(clientsCities);
        setLoading(false);
      } catch (ex) {
        setLoading(false);
        handleApiError(ex, history);
      }
    } else {
      setNewCustomerInfo({
        ...newCustomerInfo,
        [name]: value,
      });
    }
  };

  const [timeCodes, setTimeCodes] = useState([]);
  const [timeCodesError, setTimeCodesError] = useState(false);
  const fetchTimeCodesForCityAndStateAndZip = async (
    city,
    state,
    zip,
    signal,
    resetTimeCode = true,
  ) => {
    try {
      //reset timecode and time codes while we fetch new options
      setTimeCodes([]);
      if (resetTimeCode) {
        setTimeCode("");
      }
      const { data: receivedTimeCodes } =
        await getTimeCodesForCityAndStateAndZip(city, state, zip, signal);
      setTimeCodes(receivedTimeCodes);
      setIsFetchingTimeCodes(false);

      if (receivedTimeCodes?.length === 0) {
        //set timeCodesError to true if we don't get any results, as we have a problem message under it's component telling them no time codes found and to contact us for more information.
        setTimeCodesError(true);
      }
      //If they got the error, this was set to true. If they then fixed their connection and tried again, we want to set this to false to remove the error message.
      else if (timeCodesError) {
        setTimeCodesError(false);
      }
    } catch (ex) {
      if (ex?.name !== "CanceledError") {
        setIsFetchingTimeCodes(false);
        handleApiError(ex, history);
        setTimeCodesError(true);
      }
    }
  };
  const debounceFetchTimeCodesForCityAndState = useCallback(
    debounce(fetchTimeCodesForCityAndStateAndZip, 500),
    [],
  );
  const [isFetchingTimeCodes, setIsFetchingTimeCodes] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setTimeCodes([]);
    if (
      newCustomerInfo.customerCity !== "" &&
      newCustomerInfo.customerState !== "" &&
      newCustomerInfo.customerZip.length >= 5
    ) {
      try {
        setIsFetchingTimeCodes(true);
        debounceFetchTimeCodesForCityAndState(
          newCustomerInfo.customerCity,
          newCustomerInfo.customerState,
          newCustomerInfo.customerZip.substring(0, 5),
          controller.signal,
          !isModifyingExistingOrder, //Added this to make it so timecode is not reset for when loading up the page while modifying a manual entry order.
        );
      } catch (ex) {
        setIsFetchingTimeCodes(false);
        handleApiError(ex, history);
      }
    } else {
      //if all 3 fields do not have anything on change, do not fetch, reset fetch logic if it is running
      if (isFetchingTimeCodes) {
        setIsFetchingTimeCodes(false);
        controller.abort();
      }
    }
    return () => {
      controller.abort();
    };
  }, [
    newCustomerInfo.customerCity,
    newCustomerInfo.customerState,
    newCustomerInfo.customerZip,
  ]);
  //==============================================================================

  //Select Existing Customer====================================================

  const [existingOrder, setExistingOrder] = useState();
  const params = useParams();
  const modifyingDeliveryId = params.deliveryId;
  const isModifyingExistingOrder = modifyingDeliveryId ? true : false;
  //Grab City and States for this Client on Page Load

  useEffect(() => {
    //check the url to see if we are making a new order or modifying an existing order.
    //for now we are only allowing users to access the modify page through the order options menu
    //this is so they cannot try to access the page directly to modify a non-open(e.g. in transit)
    // console.log(
    //   "retrieving id: ",
    //   localStorage.getItem(constantsJS.localStorageVariables.lastModifying)
    // );
    // console.log("url id: ", modifyingDeliveryId);
    if (
      isModifyingExistingOrder &&
      localStorage.getItem(constantsJS.localStorageVariables.lastModifying) !==
        modifyingDeliveryId
    ) {
      history.push(constantsJS.pages.orderHistory.url);
      toast.error(
        `${constantsJS.errorCodes.modifyPageDirectly.errorCode}\n${constantsJS.errorCodes.modifyPageDirectly.errorMessage}`,
      );
      return;
    } else {
      localStorage.setItem(constantsJS.localStorageVariables.lastModifying, "");
    }
    // if()

    //grab city and states for client
    //on city and state selection for client
    //grab customer list for that city and state,
    //on customer select, grab time codes
    //do same for account lookup and manual entry
    //display can't ship to this location with same logic as ismael or cnls if that has logic for that
    //probably more to do
    //
    const initializePage = async () => {
      setLoading(true);
      setViewState(viewStates.loading);
      let loadedEverythingSuccessfully = true;

      //decode and store JWT into code
      try {
        const tokenInfo = jwtDecode(localStorage.getItem(tokenKeyName));
        tokenInfo.CustomerByAccountClient
          ? setCustomerSelectionType(customerSelectionTypes.account)
          : setCustomerSelectionType(customerSelectionTypes.existing);
        setClientJWTInfo(tokenInfo);
      } catch (ex) {
        setLoading(false);
        loadedEverythingSuccessfully = false;
        toast.error(
          "Problem reading authentication token. Please try signing in again.",
        );
        history.push(constantsJS.pages.loginPage.url);
      }

      try {
        const top10CustomersResponse = await getTop10CustomersForClient();
        setTop10Customers(top10CustomersResponse.data);
        // setCustomers(top10CustomersResponse.data);
      } catch (ex) {
        setLoading(false);
        handleApiError(ex, history);
      }

      //if we are modifying an order, grab the order's details and initialize the page with those values.
      if (isModifyingExistingOrder) {
        let foundOrder = null;
        //get the details of the order we are modifying from the backend
        try {
          //Making it so if they try to access the page directly, kick them out instead of having to validate the status.
          // if (
          //   modifyingDeliveryId !==
          //   localStorage.getItem(
          //     constantsJS.localStorageVariables.lastModifying
          //   )
          // ) {
          //   toast.error("Please modify order through order options menu.");
          //   history.push(constantsJS.pages.orderHistory.url);
          //   setLoading(false);
          // }
          // console.log("params:");
          // console.log(params);
          // console.log(modifyingDeliveryId);
          const response = await getExistingOrder(
            parseInt(modifyingDeliveryId),
          );
          //page seems to error out from backend if they try to visit it using a return or buyout order, so not adding validation for that for now.
          //validate that they are within the time window for modifiying orders
          //currently users can modify orders up until midnight of the day the order was placed
          //=================================================
          //this page is no longer accessible without clicking it through the options menu (entering the url directly will not work)
          //all the logic to determine if users should be able to access this page is taken care of in the options menu as well, so no need to do it again here
          //made this decision as it was taking 20+ seconds to call orderDetailsOld to get the status for open orders, the only orders available to modify. So all users with good intent would get a big delay
          //however the next day it started to only take 3-4 seconds for the data to come back
          //verify if it was just slowed down at that time and if it is viable to re-enable access to this page via url and redoing the access checks here.
          //=================================================
          // if (
          //   !dateBeforeMidnightOfCreationDate(
          //     new Date(response.data.creationDate),
          //     new Date()
          //   )
          // ) {
          //   throw new Error("Action Not Supported");
          // }
          //COMMENTING THIS OUT BECAUSE CALLS TO ORDERDETAILSOLD
          //TAKE A LONG TIME FOR OPEN ORDERS
          //SO ORDERS THAT SHOULD ACTUALLY BE MODIFIABLE WOULD TAKE 20+ seconds to load
          // //validate the order is open. Only open orders can be modified.
          // const orderDetailsOldResponse = await getOrderDetailsOld(
          //   modifyingDeliveryId,
          //   isClient()
          // );
          // // console.log(orderDetailsOldResponse.data[0].deliveryInfo);
          // if (
          //   orderDetailsOldResponse.data[0].deliveryInfo.status !==
          //   constantsJS.orderStatuses.open
          // ) {
          //   throw new Error("Action Not Supported");
          // }

          // console.log("existing order");
          foundOrder = response.data;
          setExistingOrder(foundOrder);
          // console.log(foundOrder);
        } catch (ex) {
          // if (ex.message === "Action Not Supported") {
          //   history.push(constantsJS.pages.orderHistory.url);
          //   toast.error("This action is not supported for this order.");
          //   setLoading(false);
          //   return;
          // }
          setLoading(false);
          // console.log("why no error");
          loadedEverythingSuccessfully = false;
          // console.log("failed gete existing order");
          // console.log(loadedEverythingSuccessfully);
          handleApiError(ex, history);
          // history.push("/post-order"); //if they are trying to modify an order that does not exist, send them to the post order page.
          //set error message to say Could not find specified order instead?
          setErrorViewStateMessage("The specified order could not be found.");
        }
        if (foundOrder) {
          // console.log(foundOrder);
          try {
            setLoading(true);
            if (foundOrder.customerAccountId) {
              setCustomerSelectionType(customerSelectionTypes.account);
              setTimeCodes([foundOrder.timeCode]); //since we no longer allow modification of these and we don't currently get other available timecodes, we can hard code the timecode that was originally selected as the only available option. I think we need to provide at least 1 option or else it doesn't show up.
              setTimeCode(foundOrder.timeCode);
              setAccountNumberToLookup("" + foundOrder.customerAccountId);
              const { data: foundCustomer } =
                await getCustomersForAccountNumber(
                  foundOrder.customerAccountId,
                );
              setFoundAccountCustomer(foundCustomer);
            }
            //Get City and States for Existing Customer dropdown
            else if (foundOrder.customerId) {
              setCustomerSelectionType(customerSelectionTypes.existing);
              //1. fetch city and states
              const cityAndStateResponse = await getCityAndStates();
              // console.log(cityAndStateResponse.data);
              // console.log(foundOrder.existingCustomerInfo.city);
              // console.log(foundOrder.existingCustomerInfo.state);
              //2. find the city and state that this order was for
              let existingOrderCityAndState = cityAndStateResponse.data.find(
                (cityState) => {
                  return (
                    cityState.city.toLowerCase() ===
                      foundOrder.existingCustomerInfo.city.toLowerCase() &&
                    cityState.state.toLowerCase() ===
                      foundOrder.existingCustomerInfo.state.toLowerCase()
                  );
                },
              );
              if (existingOrderCityAndState == undefined) {
                throw new Error(
                  `It looks like you do not have access to this destination city. If this is incorrect, please contact ${constantsJS.emails.supportEmail}.`,
                );
                return;
                // console.log(
                //   "existing order city and state undefined",
                //   existingOrderCityAndState
                // );
              }
              //3. get the customers of that city and state
              const customerFetchResponse = await getCustomersForCityAndState(
                existingOrderCityAndState.city.trim(),
                existingOrderCityAndState.state.trim(),
              );
              // console.log(customerFetchResponse);

              //4. set the states to correspond with the aforementioned data

              setCityAndStates(cityAndStateResponse.data);
              setCityAndState(
                existingOrderCityAndState.city.toLowerCase() +
                  "-" +
                  existingOrderCityAndState.state.toLowerCase(),
              );

              setCustomers(customerFetchResponse.data);
              let existingOrderExistingCustomerIndex =
                customerFetchResponse.data.findIndex((customer) => {
                  return customer.customerId === foundOrder.customerId;
                });
              // console.log(existingOrderExistingCustomerIndex);
              if (existingOrderExistingCustomerIndex === -1) {
                toast.error(
                  `Customer was not found. Please contact ${constantsJS.emails.supportEmail} for assistance or select another customer.`,
                );
                // throw new Error(
                //   `Customer was not found. Please contact ${constantsJS.emails.supportEmail} for assistance.`
                // );
              } else {
                setCustomerIndex(existingOrderExistingCustomerIndex);
                // console.log(customerFetchResponse);
                setCustomerComboboxSearchTerm(
                  generateCustomerDropdownDisplay(
                    customerFetchResponse.data[
                      existingOrderExistingCustomerIndex
                    ],
                  ),
                );
                setTimeCodes(
                  customerFetchResponse.data[existingOrderExistingCustomerIndex]
                    .timeCodes,
                );
                if (timeCodesError) {
                  setTimeCodesError(false);
                }
                setTimeCode(foundOrder.timeCode);
              }
            } else {
              //still want to get city and states in case they want to switch to a diff customer that exists. I.e. This is for manual orders, but if they switch to by existing customer they will have the citie/states available. Can change it to only call this when they switch to customer list however.
              const cityAndStateResponse = await getCityAndStates();
              // const getCitiesForStateResponse = await getCitiesForState();
              // const timeCodesResponse = await getTimeCodesForCityAndState(
              //   foundOrder.customerCity.trim(),
              //   foundOrder.customerStateAbbreviation.trim()
              // );
              setCityAndStates(cityAndStateResponse.data);
              // console.log(cityAndStateResponse.data);
              const citiesForStateResponse = await getCitiesForState(
                foundOrder.customerStateAbbreviation,
              );
              setCitiesForState(citiesForStateResponse.data.clientCity);
              // setCitiesForState();
              setNewCustomerInfo({
                customerName: foundOrder.customerName,
                customerAddress: foundOrder.customerAddress,
                customerCity: foundOrder.customerCity,
                customerState: foundOrder.customerStateAbbreviation,
                customerZip: foundOrder.customerZipCode,
                customerPhone: foundOrder.customerPhoneNumber,
              });

              // setTimeCodes(timeCodesResponse.data);
              setTimeCode(foundOrder.timeCode);
              setCustomerSelectionType(customerSelectionTypes.new);
            }

            const dropShipInfoResponse = await getDropShipInfos();
            // console.log(dropShipInfoResponse);
            setDropshipClients(dropShipInfoResponse.data);

            setOrderInfo({
              CODType: foundOrder.codType,
              referenceNumber: foundOrder.refNo,
              pieceAmount: foundOrder.pieceCount,
              pieceType: foundOrder.pieceType.trim(), //when sending "piece" piece type we send it as "", the server receives it as "", but in the database it ends up being " "???
              weight: foundOrder.weight,
              comments: foundOrder.comment,
            });
            setInvoices([
              {
                invoiceNumber: foundOrder.invoiceNumber,
                invoiceAmount: foundOrder.amount,
                wantsValuationCoverage: foundOrder.wantsValuationCoverage,
              },
              // ...foundOrder.invoiceList,
              ...foundOrder.invoiceList.map((invoice) => {
                return {
                  invoiceNumber: invoice.invoiceNumber,
                  invoiceAmount: invoice.invoiceAmount,
                  wantsValuationCoverage: invoice.coverage, //map coverage to wantsValuationCoverage, backend uses coverage but i was using wantsValuationCoverage because i keep all invoices including the first one in an array with objects that have the same keys.
                };
              }),
            ]);
            setLoading(false);
          } catch (ex) {
            setLoading(false);
            loadedEverythingSuccessfully = false;
            handleApiError(ex, history);
          }
        }
      }

      //if we are not modifying an existing order
      //just grab the city and states for the first drop down menu
      //and drop ship customers(also our clients?) for this client (maybe in future check if this is a drop ship client before requesting drop ship customers)
      else {
        //Grab data from backend.
        //Initialize page for new order.
        try {
          setLoading(true);
          //Get City and States for Existing Customer dropdown
          const cityAndStateResponse = await getCityAndStates();
          // console.log(cityAndStateResponse);
          setCityAndStates(cityAndStateResponse.data);
          const dropShipInfoResponse = await getDropShipInfos();
          // console.log(dropShipInfoResponse);
          setDropshipClients(dropShipInfoResponse.data);

          setLoading(false);
        } catch (ex) {
          setLoading(false);
          loadedEverythingSuccessfully = false;
          // console.log(viewState);
          handleApiError(ex, history);
        }
      }

      // console.log("final check");
      // console.log(loadedEverythingSuccessfully);
      if (loadedEverythingSuccessfully) {
        setViewState(viewStates.success);
      } else {
        setViewState(viewStates.error);
      }
    };
    initializePage();
  }, [history, setLoading]);
  // console.log(viewState);
  //City/State Dropdown
  const [cityAndStates, setCityAndStates] = useState([]);
  const [cityAndState, setCityAndState] = useState("");
  const handleSelectCityAndState = async (e) => {
    const selectedCityAndState = e.target.value;
    setCustomers([]);
    setCustomerIndex(); //reset chosen customer whenver city/state is changed
    setTimeCodes([]); // reset time codes
    setTimeCode("");
    setTimeCodesError(false);

    setCityAndState(selectedCityAndState);
    if (selectedCityAndState === "") {
      //if "select city" was selected, we shouldn't fetch any customers, just return
      return;
    }

    //if an actual city/state was selected, find customers for that city and state
    const [city, state] = selectedCityAndState.split("-");
    try {
      setLoading(true);
      const customerFetchResponse = await getCustomersForCityAndState(
        city.trim(),
        state.trim(),
      );
      // console.log(customerFetchResponse);
      setCustomers(customerFetchResponse.data);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      handleApiError(ex, history);
    }
  };
  const [top10Customers, setTop10Customers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerIndex, setCustomerIndex] = useState(); //index
  const [customerComboboxSearchTerm, setCustomerComboboxSearchTerm] =
    useState("");

  const handleClearCurrentValue = () => {
    setCustomerIndex();
    setTimeCodes([]);
    setTimeCode("");
  };
  const handleSelectCustomerOption = async (display, selectedCustomerIndex) => {
    // console.log(display);
    // console.log(selectedCustomerIndex);
    setCustomerComboboxSearchTerm(display);
    setCustomerIndex(selectedCustomerIndex);
    //reinitialize time code and cod options state
    setTimeCodes([]);
    setTimeCode("");
    setOrderInfo({
      ...orderInfo,
      CODType: codOptions.None.value,
    });
    if (selectedCustomerIndex) {
      //non empty i.e. they are not deselecting customer/selecting "Selet Customer"
      const selectedCustomerObject = customers[selectedCustomerIndex];
      try {
        setLoading(true);
        //get time codes
        const timeCodeResponse = await getTimeCodesForCityAndStateAndZip(
          selectedCustomerObject.customerCity,
          selectedCustomerObject.customerState,
          selectedCustomerObject.customerZip.substring(0, 5),
        );
        // console.log(timeCodeResponse);
        setTimeCodes(timeCodeResponse.data);
        if (timeCodesError) {
          setTimeCodesError(false);
        }
        setTimeCode("");

        //if we received no time codes set timeCodesError to true. What the problem message should be is hardcoded in its dilitextCP component
        if (timeCodeResponse?.data?.length === 0) {
          setTimeCodesError(true);
        } else {
          //else set it back to false
          setTimeCodesError(false);
        }

        //get cod default
        const { data: customerDefaultCODTypeSettings } =
          await getCustomerDefaultCODTypeSettings(
            customers[selectedCustomerIndex].customerId,
          );
        setOrderInfo({
          ...orderInfo,
          CODType: determineDefaultCODTypeSetting(
            customerDefaultCODTypeSettings,
          ),
        });
      } catch (ex) {
        if (ex?.response?.status === 401) {
          handleApiError(ex, history);
        } else {
          toast.error(
            "Issue retrieving Time Codes and/or default COD type for this customer. Please make sure you are connected to the internet and try again.\nContact Diligent at DCPSupport@diligentusa.com if the issue persists.",
            { autoClose: 10000 },
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const determineDefaultCODTypeSetting = (CODDefaultObject) => {
    if (CODDefaultObject.cashDefault) {
      return codOptions.CertifiedFunds.value;
    } else if (CODDefaultObject.codDefault) {
      return codOptions.COD.value;
    } else {
      return codOptions.None.value;
    }
  };
  // console.log(cityAndState);
  // console.log(customers[customerIndex]);
  const generateDefaultCODTypeSettingToSaveObject = () => {
    if (orderInfo.isDefaultChecked) {
      if (orderInfo.CODType === codOptions.COD.value) {
        return {
          Cod_Default: true,
          Cash_Default: false,
        };
      } else if (orderInfo.CODType === codOptions.CertifiedFunds.value) {
        return {
          COD_Default: false,
          Cash_Default: true,
        };
      } else {
        return {
          COD_Default: false,
          Cash_Default: false,
        };
      }
    } else {
      return null;
    }
  };

  const handleSelectTop10CustomerFromCombobox = async (
    display,
    value,
    dataset,
  ) => {
    // console.log(
    //   "new select top 10 customer select",
    //   display,
    //   "\n",
    //   value,
    //   "\n",
    //   dataset
    // );
    // console.log(e.target.dataset);
    // const dataset = e.target.options[e.target.selectedIndex].dataset; //because e.target can pick up child elements, which don't have the data attributes
    // console.log(dataset);

    try {
      setCityAndState(
        dataset.city.toLowerCase() + "-" + dataset.state.toLowerCase(),
      );
      setLoading(true);
      const customersResponse = await getCustomersForCityAndState(
        dataset.city,
        dataset.state,
      );
      setCustomerIndex(); //reinitialize customer index because, if we already had a customer selected, our index might be for example 300, but when we set the new list of customers there might only be 200 entries, and if react decides not to batch our setcustomerindex call below, it will error out. So we reinitialize it to make sure that never happens.
      setCustomers(customersResponse.data);
      // console.log(customersResponse.data);

      // console.log("dataset customer id", dataset.customerId);
      // console.log(customersResponse);
      //Just make sure the customer is actually in the list of their customers
      const foundCustomerIndex = customersResponse.data.findIndex(
        (customer) => {
          return "" + customer.customerId === "" + dataset.customerId;
        },
      );
      // console.log(foundCustomerIndex);
      // console.log(dataset);
      // console.log(dataset.customerId);
      // console.log("selelcted value", value);
      if (foundCustomerIndex !== -1) {
        //if not found. it should always be found unless I guess they removed that customer/citystate, but in case it isn't just throw up an error toast.
        setCustomerIndex("" + foundCustomerIndex);
        setCustomerComboboxSearchTerm(value); //the value is just the customer name and address (for the top 10 customer dropdown we display name, address, city, state, time code. After selecting one we switch to the normal customer dropdown that only displays name and address as the city state dropdown is populated separately as well as the time code dropdown.)
        // console.log(customersResponse.data[foundCustomerIndex].timeCodes);

        //You can get the city/state/zip data necessary to fetch time codes using the below method but we also have the data in the dataset of the option element
        // const timeCodeResponse = await getTimeCodesForCityAndStateAndZip(
        //   customersResponse.data[foundCustomerIndex].customerCity,
        //   customersResponse.data[foundCustomerIndex].customerState,
        //   customersResponse.data[foundCustomerIndex].customerZip.substring(0, 5)
        // );
        const timeCodeResponse = await getTimeCodesForCityAndStateAndZip(
          dataset.city,
          dataset.state,
          dataset.zip.substring(0, 5),
        );
        // console.log(timeCodeResponse);
        setTimeCodes(timeCodeResponse.data);
        setTimeCode("");
        // setTimeCodes(customersResponse.data[foundCustomerIndex].timeCodes);
        // setTimeCode(dataset.timecode);

        try {
          const { data: customerDefaultCODTypeSettings } =
            await getCustomerDefaultCODTypeSettings(dataset.customerId);

          // console.log(customerDefaultCODTypeSettings);
          // console.log(
          //   determineDefaultCODTypeSetting(customerDefaultCODTypeSettings)
          // );
          setOrderInfo({
            ...orderInfo,
            CODType: determineDefaultCODTypeSetting(
              customerDefaultCODTypeSettings,
            ),
          });
        } catch (ex) {
          if (ex.response.status === 401) {
            handleApiError(ex, history);
          } else {
            toast.error(
              "Issue retrieving default COD type for this customer. Please enter COD type manually.",
            );
          }
        }
      } else {
        toast.error("There was an issue selecting this customer.");
      }
      setLoading(false);
    } catch (ex) {
      handleApiError(ex, history);
      setLoading(false);
      toast.error("There was an issue selecting this customer.");
    }
  };

  //current time code selection for existing customer selection
  const [timeCode, setTimeCode] = useState("");
  const handleSelectTimeCode = (e) => {
    setTimeCode(e.target.value);
  };
  //============================================================================

  //Enter Customer Manually=====================================================
  // const [customerInfo, setCustomerInfo] = useState({
  //   name: "",
  //   address: "",
  //   city: "",
  //   state: "",
  //   zip: "",
  //   phone: "",
  // });
  // const handleCustomerInfoChange = (e) => {
  //   setCustomerInfo({ ...customerInfo, [e.target.name]: e.target.value });
  // };
  //============================================================================

  //Look up Customer by Account Number==========================================
  const [accountNumberToLookup, setAccountNumberToLookup] = useState("");
  const [foundAccountCustomer, setFoundAccountCustomer] = useState(null);
  const [showAccountNotFoundHelperText, setShowAccountNotFoundHelperText] =
    useState(false);
  const handleChangeAccountNumber = (e) => {
    setAccountNumberToLookup(e.target.value);
  };
  // const [customerToShow, setCustomerToShow] = useState();
  // const [showCustomerByAccount, setShowCustomerByAccount] = useState(false);
  const handleClickFindAccount = async () => {
    if (!accountNumberToLookup) {
      toast.error("Please enter an account number for lookup.");
      return;
    }
    setTimeCodes([]);
    setTimeCode("");
    setFoundAccountCustomer(null);

    try {
      setLoading(true);
      setShowAccountNotFoundHelperText(false);
      const { data: foundCustomer } = await getCustomersForAccountNumber(
        accountNumberToLookup,
      );
      if (foundCustomer) {
        try {
          //returns true for cod, false for none
          const { data: customerDefaultCODTypeSettings } =
            await getCustomerDefaultCODTypeSettings(foundCustomer.customerId);
          // console.log(customerDefaultCODTypeSettings);
          // console.log(
          //   determineDefaultCODTypeSetting(customerDefaultCODTypeSettings)
          // );
          setOrderInfo({
            ...orderInfo,
            CODType: determineDefaultCODTypeSetting(
              customerDefaultCODTypeSettings,
            ),
          });
        } catch (ex) {
          if (ex.response.status === 401) {
            handleApiError(ex, history);
          } else {
            toast.error(
              "Issue retrieving default COD type for this customer. Please enter COD type manually.",
            );
          }
        }
      }
      // setCustomerAccountId(foundCustomer.customerAccountId);
      setFoundAccountCustomer(foundCustomer);
      // console.log(foundCustomer);
      const sortedTimeCodes = sortAccountLookupTimeCodes(
        foundCustomer.timeCodes ?? [],
      );
      setTimeCodes(sortedTimeCodes);
      setTimeCode(sortedTimeCodes[0] ?? "");
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      if (ex.response.status === 404) {
        setShowAccountNotFoundHelperText(true);
      }
      // console.log("hi inside order page");
      handleApiError(ex, history);
    }
  };
  // console.log(timeCode);
  // console.log(
  //   customers.map((customer) => {
  //     return customer.customerId;
  //   })
  // );

  //==============================================================================
  //============================Dropship Logic ====================================
  const [dropshipClients, setDropshipClients] = useState([]);
  const [selectedDropshipClient, setSelectedDropshipClient] = useState("");
  const handleSelectDropshipClient = (e) => {
    setSelectedDropshipClient(e.target.value);
  };

  //------------Modal Section-------------------------//
  const [modalContent, setModalContent] = useState({
    title: "",
    body: "",
    confirmClick: null,
  });
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  //------------End Modal Section-------------------------//

  //==============================Invoice List Section ==================================//

  const [invoices, setInvoices] = useState([{ ...InvoiceTemplate }]);
  const handleInvoiceNumberKeyUp = (e) => {
    if (e.key === ",") {
      toast.error(
        "Commas are not allowed in invoices. Please add additional invoices or try another symbol if necessary.",
      );
    }
  };
  const handleChangeInvoiceNumber = (e, invoiceIndex) => {
    // console.log(
    //   "changing invoice number of " + invoiceIndex + " to: " + e.target.value
    // );
    // let updatedInvoices = [...invoices];
    setInvoices((prevInvoices) => {
      // console.log(prevInvoices);
      //only show the comma error toast if a comma is added when previously there wasn't. Put this into the handleInvoiceNumberKeyUp function defined above for the key up event instead.
      // if (
      //   !prevInvoices[invoiceIndex].invoiceNumber?.includes(",") &&
      //   e.target.value.includes(",")
      // ) {
      //   toast.error(
      //     "Commas are not allowed in invoices. Please add additional invoices or try another symbol if necessary."
      //   );
      // }
      let updatedInvoices = [...prevInvoices]; // for reference, this is a shallow copy, keep in mind.
      updatedInvoices[invoiceIndex].invoiceNumber = e.target.value; //this update will affect prevInvoices, but at this point we've already done what we needed.
      // console.log("prev", prevInvoices[invoiceIndex].invoiceNumber); //are now the same
      // console.log("updated", updatedInvoices[invoiceIndex].invoiceNumber); //are now the same
      return updatedInvoices;
    });
  };
  //duplicate invoices already exist in the system confirmation modal logic
  const [showDuplicateInvoiceModal, setShowDuplicateInvoiceModal] =
    useState(false);
  const handleHideDuplicateInvoiceModal = () => {
    setShowDuplicateInvoiceModal(false);
  };
  //this is to be called onBlur of the invoice number inputs
  const handleFinishEnteringInvoiceNumber = async (e, invoiceIndex) => {
    // console.log(e.target.value);
    try {
      const invoiceToCheck = e.target.value;
      if (invoiceToCheck?.trim()?.length === 0) {
        return;
      }
      const { data: existsInSystem } = await checkInvoiceAlreadyExists(
        invoiceToCheck?.trim(),
      );

      // let updatedInvoices = [...invoices];
      // updatedInvoices[invoiceIndex].alreadyExistsInSystem = existsInSystem;
      // console.log("updated to: ", updatedInvoices);
      // setInvoices(updatedInvoices);
      setInvoices((prevInvoices) => {
        let updatedInvoices = [...prevInvoices];
        updatedInvoices[invoiceIndex].alreadyExistsInSystem = existsInSystem;
        // console.log("updated to: ", updatedInvoices);
        return updatedInvoices;
      });
    } catch (ex) {
      //choosing to silently fail for now.
    }
  };

  const handleChangeDeclaredValue = (e, invoiceIndex) => {
    setInvoices((prevInvoices) => {
      let updatedInvoices = [...prevInvoices];
      updatedInvoices[invoiceIndex].invoiceAmount = e.target.value;
      return updatedInvoices;
    });
  };
  const handleToggleIsPurchasingInsurance = (e, invoiceIndex) => {
    setInvoices((prevInvoices) => {
      let updatedInvoices = [...prevInvoices];
      updatedInvoices[invoiceIndex].wantsValuationCoverage = e.target.checked;
      // console.log(invoices);
      return updatedInvoices;
    });
  };
  const addInvoice = () => {
    if (invoices.length < maxInvoices) {
      let updatedInvoices = [...invoices];
      updatedInvoices.push({ ...InvoiceTemplate });
      setInvoices(updatedInvoices);
    }
  };
  const handleChangeNumberOfInvoices = (e) => {
    //capture e.target.value here into a variable, because for some reason when passing e.target.value into the
    //confirm click function of the modal, it uses the old value. /-Look into why-/
    const newAmountOfInvoices = e.target.value;
    // console.log("TODO");
    //remember to add modal for this if the amount is less than the current amount (as in they would lose invoice cards) ****************
    //if it's the same amount of invoices as we already have, do nothing.
    if (newAmountOfInvoices === invoices.length) {
      return;
    }
    //if they want more invoices, just add the difference to the invoice list
    if (newAmountOfInvoices > invoices.length) {
      let updatedInvoices = [...invoices];
      for (let i = 0; i < newAmountOfInvoices - invoices.length; i++) {
        updatedInvoices.push({ ...InvoiceTemplate });
      }
      setInvoices(updatedInvoices);
    }
    //if they want less, splice everything after the amount they want off,
    if (newAmountOfInvoices < invoices.length) {
      setModalContent({
        title:
          "Deleting last " +
          (invoices.length - newAmountOfInvoices > 1
            ? invoices.length - newAmountOfInvoices + " Invoices."
            : "Invoice"),
        body: "You will lose any data that you may have entered in these rows.",
        confirmClick: () => {
          // console.log("clickeddddd");
          // console.log(newAmountOfInvoices);
          // console.log(newAmountOfInvoices);
          let updatedInvoices = [...invoices];
          updatedInvoices.splice(newAmountOfInvoices);
          setInvoices(updatedInvoices);
          handleCloseModal();
        },
      });
      handleShowModal();
    }
  };
  //User presses delete on a card, showDeleteInvoiceModal is called where we set the onclick of the confirm button of that modal to call this deleteInvoice() function
  const deleteInvoice = (invoiceIndex) => {
    let updatedInvoices = [...invoices];
    updatedInvoices.splice(invoiceIndex, 1);
    setInvoices(updatedInvoices);
  };
  //showDeleteInvoiceModal when Delete is pressed, then that calls deleteInvoice();
  const showDeleteInvoiceModal = (invoiceIndex) => {
    setModalContent({
      title: "Deleting Invoice",
      body:
        "Are you sure you wish to delete Invoice #" + (invoiceIndex + 1) + "?",
      confirmClick: () => {
        deleteInvoice(invoiceIndex);
        handleCloseModal();
      },
    });
    handleShowModal();
  };

  //=================================END INVOICE LIST SECTION==========================================================//

  //======================= useMemo for dropdown options==============================================//
  //doing this instead of mapping over the list every render helps a lot with lag
  const cityAndStateOptions = useMemo(() => {
    return (
      <>
        <option value="">Select City</option>
        {cityAndStates.map((cityAndState, index) => {
          return (
            <option
              key={index + "-" + cityAndState.city + "-" + cityAndState.state}
              value={
                cityAndState.city.toLowerCase() +
                "-" +
                cityAndState.state.toLowerCase()
              }
            >
              {cityAndState.city + ", " + cityAndState.state}
            </option>
          );
        })}
      </>
    );
  }, [cityAndStates]);
  const customerOptions = useMemo(() => {
    // console.log("recalculate customers combobox");
    return customers.map((customer, index) => {
      return {
        display: generateCustomerDropdownDisplay(customer),
        value: "" + index, //this is to fix issue if the you do 0 && <Component/> it displays the 0
      };
    });
  }, [customers]);
  const top10customerOptions = useMemo(() => {
    // console.log("recalculate top 10 customers combobox");
    return top10Customers.map((customer, index) => {
      const timecode = customer.route.split("-").at(-1);

      return {
        display: generateCustomerDropdownDisplay(customer, true),
        value: `${customer.customerName.trim()} - ${customer.customerAddress.trim()}`,
        data: {
          city: customer.customerCity.trim(),
          state: customer.customerState.trim(),
          zip: customer.customerZip?.trim(),
          customerId: customer.customerid,
          timecode: timecode,
        },
      };
    });
  }, [top10Customers]);

  //===================== End useMemo for dropdown options =========================//

  //Label source state for Auto Initiate Print component
  //set this when the label is retrieved, if their print method is directToPrint
  const [labelSrc, setLabelSrc] = useState();

  //===Label Modal to replace Popup ===//
  const [labelViewerModalData, setLabelViewerModalData] = useState({
    show: false,
    deliveryId: null,
  });
  const handleShowLabelViewerModal = (deliveryId) => {
    setLabelViewerModalData({
      show: true,
      deliveryId: deliveryId,
    });
  };
  const handleHideLabelViewerModal = () => {
    if (isModifyingExistingOrder) {
      window.close();
    }
    setLabelViewerModalData((prev) => {
      return { ...prev, show: false }; // leave the old delivery id to avoid the labelviewer component from trying refetch the label with null passed in
    });
  };

  //========================= Posting Order Form ===================================//
  //from ismael's PostOrderContainer
  const processOrder = async (orderRequest) => {
    // const newWindow = window.open("processing-order", "_blank"); // may want to add "noopener" into windowsFeatures parameter, almost all current browsers do this by default but may be more secure for old browsers.

    // console.log(newWindow);

    // try {
    //   const { data: response } = await postOrder(orderRequest);
    //   toast.success(`Order has been processed.`);
    //   const redirectUrl = generatePath("/view-labels/:id", {
    //     id: response.deliveryId,
    //   });
    //   newWindow.location = redirectUrl;
    //   console.log(newWindow);
    // } catch (ex) {
    //   handleApiError(ex);
    //   console.log(ex);
    // }
    // console.log("HELPP MEE PROCESS");
    try {
      setLoading(true);
      // console.log("post order help");
      // console.log(orderRequest);
      const response = await postOrder(orderRequest);
      toast.success(
        existingOrder
          ? "Order was successfully modified."
          : "Order has been processed.",
      );
      // console.log(response);
      const deliveryId = response.data.deliveryId;

      // console.log(deliveryId);

      // alert(clientJWTInfo.ClientId);
      //if the client is not in the clientsToBeExcludedFromPrintingLabels array, display/download the label for the order according to their settings.
      if (
        !constantsJS.clientsToBeExcludedFromPrintingLabels.includes(
          clientJWTInfo.ClientId,
        )
      ) {
        //handle label print method
        let postOrderLabelPrintMethod = localStorage.getItem(
          "postOrderLabelPrintMethod",
        );
        // console.log(postOrderLabelPrintMethod);
        if (
          postOrderLabelPrintMethod ===
          constantsJS.postOrderLabelPrintMethods.directToPrint
        ) {
          const { data: labelsPDF } = await getLabelsForMultipleDeliveries(
            "" + deliveryId,
            false,
            isClient(),
          );
          const labelDataURL = window.URL.createObjectURL(labelsPDF);
          setLabelSrc(labelDataURL);
        } else if (
          postOrderLabelPrintMethod ===
          constantsJS.postOrderLabelPrintMethods.download
        ) {
          const { data: labelsPDF } = await getLabelsForMultipleDeliveries(
            "" + deliveryId,
            false,
            isClient(),
          );
          fileDownload(labelsPDF, `Diligent Label-${deliveryId}.pdf`);
        } else if (
          postOrderLabelPrintMethod ===
          constantsJS.postOrderLabelPrintMethods.newTab
        ) {
          window.open(
            `${basePath}/view-labels/${deliveryId}`,
            "_blank",
            "noopener",
          );
        } else if (
          postOrderLabelPrintMethod ===
          constantsJS.postOrderLabelPrintMethods.popup
        ) {
          window.open(
            `${basePath}/view-labels/${deliveryId}`,
            "_blank",
            "noopener popup,width=750,height=900",
          );
        }
        // else if (
        //   !postOrderLabelPrintMethod ||
        //   postOrderLabelPrintMethod ===
        //     constantsJS.postOrderLabelPrintMethods.modal
        // ) {
        else {
          //MODAL
          //In any other case, default to the modal option.
          //This is the new default as popups were suddenly being blocked after a browser update for some clients.
          //Skipping the condition check to see if their value is set to modal as this is the new default.
          //Since users would have the old "popup" value saved, I have changed the value to "popupOld", so the popup condition check fails and falls to this default. Users would have to go and re-save their choice as popup to get the new popupOld value.
          handleShowLabelViewerModal(deliveryId);
        }
      }
      // console.log(data);
      setLoading(false);

      if (existingOrder) {
        // toast.success("Order was successfully modified."); // toast for this happens above
        // history.push(constantsJS.pages.orderHistory.url);
      } else {
        resetEverything();

        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      }
    } catch (ex) {
      setLoading(false);
      handleApiError(ex, history);
      // setTimeout(() => {
      //   window.scrollTo(0, 0);
      // }, 200);

      // console.log(ex);
    }
  };

  const resetEverything = () => {
    setSubmitPressed(false);
    setWasSubmittedSuccessfullyNotification((prevNotif) => {
      return prevNotif + 1;
    });
    setOrderInfo({
      CODType: "",
      referenceNumber: "",
      BOLNumber: "",
      pieceAmount: "",
      pieceType: "",
      weight: "",
      comments: "",
      isDefaultChecked: false,
    });
    reinitializeNewCustomerInfo();
    setTimeCode("");
    setTimeCodes([]);
    setCityAndState("");
    // setCityAndStates([]); //want to keep city/states and drop ship clients (we grab these two on page load so we can just keep them, if you reset them here you would need to grab them again somehow.)
    // setDropshipClients([]);
    setCustomerIndex();
    setCustomers([]);
    setAccountNumberToLookup("");
    setFoundAccountCustomer(null);
    setShowAccountNotFoundHelperText(false);
    setSelectedDropshipClient("");

    setInvoices([{ ...InvoiceTemplate }]);
  };
  // console.log(customerIndex);
  const [submitPressed, setSubmitPressed] = useState(false);

  const [
    wasSubmittedSuccessfullyNotification,
    setWasSubmittedSuccessfullyNotification,
  ] = useState(1);

  const handleSubmit = async (e, checkForDuplicateInvoices = true) => {
    e.preventDefault && e.preventDefault();
    // toast.success("testing");
    // return;
    setSubmitPressed(true);

    if (
      customerSelectionType === customerSelectionTypes.existing &&
      (customerIndex === null || customerIndex === undefined)
    ) {
      toast.error("Please select a customer.");
      return;
    }

    //some validation (we are using built in browser validation as well, but what that doesn't take care of we need to account for here)
    if (new Set(currentInvoiceNumbers).size !== invoices.length) {
      // console.log(new Set(currentInvoiceNumbers));
      toast.error("Duplicate Invoices");
      return;
    }
    if (
      currentInvoiceNumbers.find((invoiceNumber) => invoiceNumber.includes(","))
    ) {
      toast.error(
        "Commas are not allowed in invoices. Please add additional invoices or try another symbol if necessary.",
      );
      return;
    }
    //if one of the invoice numbers already exists in the system, show duplicate invoice confirmation modal instead
    if (
      checkForDuplicateInvoices &&
      invoices.some((invoice) => invoice.alreadyExistsInSystem)
    ) {
      setShowDuplicateInvoiceModal(true);
      return;
    }
    // console.log(e);
    // console.log(selectedDropshipClient);
    // console.log(invoices.slice(1));
    // console.log(
    //   invoices.slice(1).map((invoice) => {
    //     return {
    //       InvoiceNumber: invoice.invoiceNumber,
    //       InvoiceAmount: invoice.invoiceAmount,
    //       Coverage: invoice.wantsValuationCoverage,
    //     };
    //   })
    // );

    //Check to see if anything is missing / not valid
    // const isValidSubmission = true;
    // if (customerSelectionType === "existing") {
    //   if (cityAndState === "" || customer === "") {
    //     isValidSubmission = false;
    //   }
    // } else if (customerSelectionType === "account") {
    //   //TO DOOOOOOOOOOOOOO******************************
    // } else if (customerSelectionType === "new") {
    //   if (
    //     newCustomerInfo.customerName === "" ||
    //     newCustomerInfo.customerAddress === "" ||
    //     newCustomerInfo.customerCity === "" ||
    //     newCustomerInfo.customerState === "" ||
    //     newCustomerInfo.customerZip === ""
    //   ) {
    //     isValidSubmission = false;
    //   }
    // }

    // // if there's something invalid/missing, display an error and return.
    // if (!isValidSubmission) {
    //   toast.error("Please fill out all required fields.");
    //   return;
    // }

    let orderRequestCustomerInfo = {};
    if (customerSelectionType === customerSelectionTypes.account) {
      orderRequestCustomerInfo.customerAccountId =
        foundAccountCustomer.customerAccountId;
    } else if (customerSelectionType === customerSelectionTypes.existing) {
      orderRequestCustomerInfo.customerId = customers[customerIndex].customerId;
    } else if (customerSelectionType === customerSelectionTypes.new) {
      orderRequestCustomerInfo.customerName = newCustomerInfo.customerName;
      orderRequestCustomerInfo.customerAddress =
        newCustomerInfo.customerAddress;
      orderRequestCustomerInfo.customerCity = newCustomerInfo.customerCity;
      orderRequestCustomerInfo.customerStateAbbreviation =
        newCustomerInfo.customerState;
      orderRequestCustomerInfo.customerZipCode = newCustomerInfo.customerZip;
      orderRequestCustomerInfo.customerPhoneNumber =
        newCustomerInfo.customerPhone;
    }
    // new customer info
    // customerName: "",
    // customerAddress: "",
    // customerCity: "",
    // customerState: "",
    // customerZip: "",
    // customerPhone: "",

    // console.log("HELLLLPPPPP MEEEEE");
    // console.log(existingOrder.deliveryId);
    const orderRequestOrderInfo = {
      deliveryId: existingOrder ? existingOrder.deliveryId : 0, //for new orders this is 0?, otherwise the deliveryid of the existing order we are modifying
      invoiceNumber: invoices[0].invoiceNumber?.trim(), //this is going to be the first of the invoice array in our implementation I believe
      amount:
        invoices[0].invoiceAmount === ""
          ? 0
          : parseFloat(invoices[0].invoiceAmount), //must be 0 or greater
      wantsValuationCoverage:
        parseFloat(invoices[0].invoiceAmount) >
        clientJWTInfo.MinimumValuationAmount
          ? invoices[0].wantsValuationCoverage
          : false, //since the user can still enter a value above 200, enable add insurance, and then decrease the value in the row: if the amount is actually less than 200 just send false. alternatively make it so on change of declared value/amount, if add insurance was pressed and the declared value/amount falls under 200, automatically set it to false *****to do later*******.
      timeCode: timeCode,
      codType: orderInfo.CODType,
      pieceCount: parseInt(orderInfo.pieceAmount), // 1-99 //our number input is actually a tel input, so they can enter 0000000005 for example...
      pieceType: orderInfo.pieceType, //"":Piece, "S": Pallet, "E": Engine, "M": Transmission, "O": Oversized, "P": Parcel
      weight: orderInfo.weight === "" ? 0 : parseFloat(orderInfo.weight), // must be positive, if "", fill with 0?
      refNo: orderInfo.referenceNumber?.trim(), //max length 20
      BOLNumber: orderInfo.BOLNumber?.trim(),
      comment: orderInfo.comments?.trim(),
      dropShipClientId: selectedDropshipClient,
      invoiceList: invoices.slice(1).map((invoice) => {
        return {
          InvoiceNumber: invoice.invoiceNumber?.trim(),
          InvoiceAmount:
            invoice.invoiceAmount === ""
              ? 0
              : parseFloat(invoice.invoiceAmount),
          Coverage:
            parseFloat(invoice.invoiceAmount) >
            clientJWTInfo.MinimumValuationAmount
              ? invoice.wantsValuationCoverage
              : false, //since they can still enter a value above 200, enable add insurance, and then decrease the value, if the amount is actually less than 200 just send false. alternatively make it so on change of declared value/amount, if add insurance was pressed and the declared value/amount falls under 200, automatically set it to false *****to do later*******.
        };
      }),
      ...orderRequestCustomerInfo,
      isDefaultChecked: orderInfo.isDefaultChecked,
      ...generateDefaultCODTypeSettingToSaveObject(),
    };
    // console.log(orderRequestOrderInfo);
    // console.log("HELLLLPPPPP MEEEEE");

    try {
      // console.log("HELLLLPPPPP MEEEEE before api");

      await processOrder(orderRequestOrderInfo);
      // console.log("HELLLLPPPPP MEEEEE after api");

      // const response = await axios.post(
      //   `${apiUrl}Delivery/PostOrder`,
      //   orderRequestDTO
      // );
      // console.log(response);
      // console.log(e);
    } catch (ex) {
      // console.log(ex);
      handleApiError(ex);
      // console.log("Outer most submission event failed.");
      // console.log(ex);
    }
  };

  //========================= End Posting Order Form ==================================//

  // console.log(foundAccountCustomer);
  const handleOnInvalid = (e) => {
    //why is this being fired twice?
    // console.log("Submission failed due to fields missing.");
    // toast.error("Please fill out all required fields.");
    setSubmitPressed(true);
  };

  const currentInvoiceNumbers = [
    ...invoices.map((invoice) => {
      return invoice.invoiceNumber;
    }),
  ];
  // console.log(currentInvoiceNumbers);
  // begin rendering component
  // console.log(top10Customers);
  // console.log(top10customerOptions);
  // console.log(customers?.[customerIndex]?.customerId);
  // console.log("customer index", customerIndex);

  //RENDER JSX
  return (
    <>
      <Helmet>
        <title>
          {isModifyingExistingOrder ? "Modify Order" : "New Order"} -{" "}
          {defaultTitle}
        </title>
      </Helmet>
      <DuplicateInvoiceWarningModal
        showDuplicateInvoiceWarningModal={showDuplicateInvoiceModal}
        onHideDuplicateInvoiceWarningModal={handleHideDuplicateInvoiceModal}
        invoices={invoices}
        handleSubmitAsNormal={(e) => {
          handleSubmit(e, false);
        }}
        resetEverything={resetEverything}
        isModifyingExistingOrder={isModifyingExistingOrder}
      />
      <LabelViewerModal
        show={labelViewerModalData.show}
        onHide={handleHideLabelViewerModal}
        deliveryId={labelViewerModalData.deliveryId}
      />

      <div className="container paper-panel form-container">
        {localStorage.getItem("postOrderLabelPrintMethod") ===
          constantsJS.postOrderLabelPrintMethods.directToPrint && (
          <AutoInitiatePrint src={labelSrc} id="labelpdf" />
        )}
        <form
          onSubmit={handleSubmit}
          onInvalid={handleOnInvalid}
          onKeyPress={(e) => {
            //prevents enter from submitting the form while still allowing user to do a carriage return in text areas (shift + enter). It does still disable carriage returns with just enter in text areas unfortunately
            e.key === "Enter" && e.shiftKey === false && e.preventDefault();
          }}
        >
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>{modalContent.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modalContent.body}</Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-danger"
                type="button"
                onClick={modalContent.confirmClick}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
          <div className="row">
            <div className="col form-header">
              {/* check if we have a delivery id in the parameters, if we do we are modifying an order */}
              <h1>{isModifyingExistingOrder ? "Modify" : "New"} Order</h1>

              <p>
                <span className="required-star">*</span> denotes a required
                field.
              </p>
            </div>
          </div>
          {viewState === viewStates.loading && (
            <>
              <GleamPanel
                height="250px"
                className="paper-panel-always sub-panel"
              />
              <GleamPanel
                height="250px"
                className="paper-panel-always sub-panel"
              />
              <GleamPanel
                height="600px"
                className="paper-panel-always sub-panel"
              />
            </>
          )}
          {/* copied from action center viewstates.error rendering */}
          {viewState === viewStates.error && (
            <div
              style={{
                paddingTop: "300px",
                paddingBottom: "300px",
                textAlign: "center",
              }}
            >
              {errorViewStateMessage}
              <br />
              <button
                onClick={() => {
                  window.location.reload();
                }}
                style={{
                  outline: "none",
                  border: "none",
                  margin: "10px",
                  backgroundColor: "transparent",
                  fontSize: "1.5rem",
                }}
              >
                <BsArrowClockwise />
              </button>
            </div>
          )}
          {viewState === viewStates.success && (
            <>
              {/* <div className="container paper-panel sub-panel">
                <div className="sub-panel-header mb-2">
                  Top Customers In The Last 30 Days
                </div>
                <div className="pr-3">
                  <div
                    className="row custom-scrollbar pl-3 pr-2"
                    style={{
                      backgroundColor: "",
                      height: "144px",
                      overflow: "auto",
                    }}
                  >
                    {top10Customers.map((customer, index) => {
                      const timecode = customer.route.split("-").at(-1);
                      //at(-1) basically saves us from needing to do extra work to get the last element like you would usually do:
                      // customer.route.split("-")[
                      //   customer.route.split("-").length - 1
                      // ];
                      return (
                        <div
                          key={index + "-" + customer.customerid}
                          className="col-12 top10customerlist-item"
                          onClick={handleSelectTop10Customer}
                          data-city={customer.customerCity}
                          data-state={customer.customerState}
                          data-customer-id={customer.customerid}
                          data-timecode={timecode}
                        >
                          <span className="font-500">
                            {customer.customerName}
                          </span>
                          <br />
                          {customer.customerAddress}
                          <br />
                          {customer.customerCity}, {customer.customerState}{" "}
                          {customer.customerZip} | {timecode}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div> */}
              <div className="container paper-panel sub-panel">
                <div className="row sub-panel-header align-items-center">
                  <div className="col-6">Customer Info</div>
                  <div className="col-6 justify-content-end d-flex">
                    <select
                      disabled={isModifyingExistingOrder}
                      className="form-control"
                      name="customerSelectionType"
                      style={{
                        maxWidth: "fit-content",
                        textOverflow: "ellipsis",
                      }}
                      value={customerSelectionType}
                      onChange={handleChangeCustomerSelectionType}
                    >
                      {clientJWTInfo.CustomerByAccountClient && (
                        <option value={customerSelectionTypes.account}>
                          Account Lookup
                        </option>
                      )}
                      <option value={customerSelectionTypes.existing}>
                        Customer List
                      </option>
                      <option value={customerSelectionTypes.new}>
                        Manual Entry
                      </option>
                    </select>
                  </div>
                </div>
                {customerSelectionType === customerSelectionTypes.existing ? (
                  <div className="row p-2">
                    <div className="col-md-6">
                      <DiliTextCP
                        disabled={isModifyingExistingOrder}
                        className="form-group"
                        required={!isModifyingExistingOrder}
                        type="select"
                        label="City & State"
                        name="cityAndState"
                        value={cityAndState}
                        onChange={handleSelectCityAndState}
                        wasSubmitted={submitPressed}
                        successfulSubmissionNotif={
                          wasSubmittedSuccessfullyNotification
                        }
                        inputStyle={{
                          maxWidth: "fit-content",
                          textOverflow: "ellipsis",
                        }}
                        invalidText="Please select a city and state."
                      >
                        {cityAndStateOptions}
                      </DiliTextCP>
                      {/* {cityAndState === "" ? (
                        //if no city and state is selected show top 10 customers list, otherise show normal list with all customers
                        <DiliTextCP
                          className="form-group"
                          required
                          type="select"
                          name="customer"
                          label="Customer"
                          value={customerIndex}
                          wasSubmitted={submitPressed}
                          successfulSubmissionNotif={
                            wasSubmittedSuccessfullyNotification
                          }
                          validationTest={(input) => {
                            return input !== "" || customers.length === 0;
                          }}
                          onChange={handleSelectTop10Customer}
                          inputStyle={{ textOverflow: "ellipsis" }}
                          invalidText="Please select a customer."
                        >
                          {top10customerOptions}
                        </DiliTextCP>
                      ) : (
                        //
                        <DiliTextCP
                          className="form-group"
                          required
                          disabled={cityAndState === ""}
                          type="select"
                          name="customer"
                          label="Customer"
                          value={customerIndex}
                          wasSubmitted={submitPressed}
                          successfulSubmissionNotif={
                            wasSubmittedSuccessfullyNotification
                          }
                          validationTest={(input) => {
                            return input !== "" || customers.length === 0;
                          }}
                          onChange={handleSelectCustomer}
                          inputStyle={{ textOverflow: "ellipsis" }}
                          invalidText="Please select a customer."
                        >
                          {customerOptions}
                        </DiliTextCP>
                      )} */}
                      <ComboboxInfiniteLoading
                        disabled={isModifyingExistingOrder}
                        label="Customer"
                        required={!isModifyingExistingOrder}
                        validate
                        placeholder={
                          cityAndState === ""
                            ? "Select From Top Customers In The Last 30 Days"
                            : "Select Customer"
                        }
                        options={
                          cityAndState === ""
                            ? top10customerOptions
                            : customerOptions
                        }
                        currentSearchTerm={customerComboboxSearchTerm}
                        setCurrentSearchTerm={setCustomerComboboxSearchTerm}
                        currentValue={customerIndex}
                        onClearCurrentSearchTerm={handleClearCurrentValue}
                        selectFromOptionsOnly
                        onSelectOption={
                          cityAndState === ""
                            ? handleSelectTop10CustomerFromCombobox
                            : handleSelectCustomerOption
                        }
                        comboboxBackgroundColor="white"
                        comboboxBorderRadius=".25rem"
                        // autofilter={false}
                        autofilterTrim={true}
                        freesolo={false}
                        infiniteLoading
                        infiniteLoadingOptions={{
                          initialResultsCount: 500,
                          resultsAmountIncrement: 500,
                        }}
                        optionsContainerBackgroundColor="rgb(255,255,255)"
                        removeBorderBottom
                        clearSearchTermOnOptionsChange
                        showDropdownArrow
                        noResultsMessage={
                          customerComboboxSearchTerm || cityAndState
                            ? "No Customers Found"
                            : "No recent customers found. Please select a city and state to view customers for that area."
                        }
                      />
                    </div>
                    <div className="col-md-6 ">
                      {/* {console.log(
                        "new test - selected customer index",
                        customerIndex
                      )}
                      {console.log(
                        "new test - selected customer info",
                        customers[customerIndex]
                      )} */}
                      {parseInt(customerIndex) >= 0 && (
                        <NewOrderCustomerDisplay
                          name={customers[customerIndex].customerName}
                          address={customers[customerIndex].customerAddress}
                          city={customers[customerIndex].customerCity}
                          state={customers[customerIndex].customerState}
                          zip={customers[customerIndex].customerZip}
                          phone={customers[customerIndex].customerPhone}
                        />
                      )}
                    </div>
                  </div>
                ) : customerSelectionType === customerSelectionTypes.account ? (
                  <div className="row p-2">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Account Number
                          {/* put this condition here even though we usually don't show this UI for modifications by default (and won't be showing it for modifications at all unless we bring back ability to modify customer). */}
                          {!isModifyingExistingOrder && (
                            <span className="required-star">*</span>
                          )}
                        </label>
                        <input
                          disabled={isModifyingExistingOrder} //put this here even though we usually don't show this UI for modifications by default.
                          value={accountNumberToLookup}
                          onChange={handleChangeAccountNumber}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              handleClickFindAccount();
                            }
                          }}
                          type="text"
                          className="form-control"
                        />
                        {showAccountNotFoundHelperText && (
                          <small className="form-text text-danger pl-1">
                            Account Not Found
                          </small>
                        )}
                      </div>

                      <button
                        disabled={isModifyingExistingOrder} //put this here even though we usually don't show this UI for modifications by default.
                        onClick={handleClickFindAccount}
                        type="button"
                        className="btn btn-primary"
                      >
                        Find Account
                      </button>
                    </div>
                    <div className="col-md-6">
                      {foundAccountCustomer && (
                        <NewOrderCustomerDisplay
                          name={foundAccountCustomer?.customerName}
                          address={foundAccountCustomer?.customerAddress}
                          city={foundAccountCustomer?.customerCity}
                          state={foundAccountCustomer?.customerState}
                          zip={foundAccountCustomer?.customerZip}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="row p-2">
                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      required={!isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      maxLength="50"
                      label="Customer Name"
                      name="customerName"
                      value={newCustomerInfo.customerName}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      invalidText="Please enter customer's name."
                    />
                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      required={!isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      maxLength="50"
                      label="Customer Address"
                      name="customerAddress"
                      value={newCustomerInfo.customerAddress}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      invalidText="Please enter customer's address."
                    />

                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      type="tel"
                      maxLength="12"
                      label="Customer Phone"
                      name="customerPhone"
                      value={newCustomerInfo.customerPhone}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      // invalidText="Please enter customer's phone number."
                    />
                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      required={!isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      maxLength="2"
                      type="select"
                      label="Customer State"
                      name="customerState"
                      value={newCustomerInfo.customerState}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      invalidText="Please select the state your customer is located."
                    >
                      <option value="">Select State</option>
                      <option value="AL">AL</option>
                      <option value="AK">AK</option>
                      <option value="AZ">AZ</option>
                      <option value="AR">AR</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="IA">IA</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="ME">ME</option>
                      <option value="MD">MD</option>
                      <option value="MA">MA</option>
                      <option value="MI">MI</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MO">MO</option>
                      <option value="MT">MT</option>
                      <option value="NE">NE</option>
                      <option value="NV">NV</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NY">NY</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VT">VT</option>
                      <option value="VA">VA</option>
                      <option value="WA">WA</option>
                      <option value="WV">WV</option>
                      <option value="WI">WI</option>
                      <option value="WY">WY</option>
                    </DiliTextCP>
                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      required={!isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      maxLength="35"
                      label="Customer City"
                      name="customerCity"
                      type="select"
                      value={newCustomerInfo.customerCity}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      invalidText="Please select the city your customer is located."
                      helperText="Select a state to view cities."
                      showHelperText={newCustomerInfo.customerState === ""}
                      helperTextClass="text-note"
                      //if we switch to showing them only states they have cities for/access to, this will no longer be necessary
                      problemText={
                        "No cities found for this state. Contact Diligent to inquire about city availability."
                      }
                      showProblemText={
                        newCustomerInfo.customerState !== "" &&
                        citiesForState.length === 0 &&
                        !loading
                      }
                    >
                      <option value="">Select City</option>
                      {citiesForState.map((city, index) => {
                        return (
                          <option value={city} key={index + "-" + city}>
                            {city}
                          </option>
                        );
                      })}
                    </DiliTextCP>
                    <DiliTextCP
                      disabled={isModifyingExistingOrder}
                      required={!isModifyingExistingOrder}
                      className="form-group col-md-6 col-lg-4"
                      maxLength="10"
                      // pattern="^[0-9]\d*\-?\d{0,4}$"
                      pattern="^[0-9]{5}(?:-[0-9]{4})?$"
                      helperText={"55555 ( -5555 )"}
                      helperTextClass="text-note"
                      showHelperText
                      label="Customer Zip"
                      name="customerZip"
                      value={newCustomerInfo.customerZip}
                      onChange={handleChangeNewCustomerInfo}
                      wasSubmitted={submitPressed}
                      successfulSubmissionNotif={
                        wasSubmittedSuccessfullyNotification
                      }
                      invalidText="Please enter customer's zip code."
                    />
                  </div>
                )}
                {isModifyingExistingOrder && (
                  <div className="col-12 text-note font-small">
                    Note: If you wish to modify customer, destination, or time
                    code, please void this order and create a new one with the
                    correct information.
                  </div>
                )}
              </div>
              <div className="container paper-panel sub-panel">
                <div className="row sub-panel-header align-items-center">
                  <div className="col-sm-6">Order Info</div>
                </div>
                {dropshipClients.length > 0 && (
                  <div className="row p-2">
                    <div className="col-md-6">
                      <label>Dropship Client</label>
                      <select
                        className="form-control"
                        name="dropshipclient"
                        value={selectedDropshipClient}
                        onChange={handleSelectDropshipClient}
                      >
                        <option value="">Direct Ship</option>
                        {dropshipClients.map((dsClient, index) => {
                          return (
                            <option
                              key={
                                dsClient.dropShipClientName +
                                "-" +
                                dsClient.dropShipClientId +
                                "-" +
                                index
                              }
                              value={dsClient.dropShipClientId}
                            >
                              {dsClient.dropShipClientName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}
                <div className="row p-2">
                  {/* *******remember to look at timecodeselecter.jsx - something there sometimes warns we are not able to deliver to certain combinations of city/state/timecode? */}
                  <div className="col-lg-6">
                    <div className="row">
                      <DiliTextCP
                        className="form-group col-lg-6"
                        required={!isModifyingExistingOrder}
                        disabled={
                          isModifyingExistingOrder ||
                          (timeCodes.length <= 0 &&
                            !(
                              customerSelectionType ===
                                customerSelectionTypes.new ||
                              customerSelectionType ===
                                customerSelectionTypes.account
                            ))
                        }
                        type="select"
                        name="timecode"
                        label="Time Code"
                        loading={isFetchingTimeCodes}
                        value={timeCode}
                        validationTest={(value) => {
                          // console.log(timeCodes);
                          return value.length > 0 || timeCodes.length === 0;
                        }}
                        wasSubmitted={submitPressed}
                        successfulSubmissionNotif={
                          wasSubmittedSuccessfullyNotification
                        }
                        onChange={handleSelectTimeCode}
                        helperText={
                          customerSelectionType === customerSelectionTypes.new
                            ? "Please fill out customer city, state, and zip to see time codes."
                            : customerSelectionType ===
                                customerSelectionTypes.account
                              ? "Please find a customer to see time codes."
                              : ""
                        }
                        showHelperText={
                          (customerSelectionType ===
                            customerSelectionTypes.new &&
                            (newCustomerInfo.customerCity === "" ||
                              newCustomerInfo.customerState === "" ||
                              newCustomerInfo.customerZip.length < 5)) ||
                          (customerSelectionType ===
                            customerSelectionTypes.account &&
                            !foundAccountCustomer?.customerAccountId)
                        }
                        helperTextClass="text-note"
                        invalidText="Please select a time code."
                        // problemText="We are currently unable to deliver to this location for you. Please contact us for more details."
                        // showProblemText={
                        //   newCustomerInfo.customerCity !== "" &&
                        //   newCustomerInfo.customerState !== "" &&
                        //   timeCodes.length <= 0
                        // }
                        problemText={
                          timeCodes.length === 0
                            ? "No Time Codes found for this destination. Please contact us for more information."
                            : "There was an error retrieving time codes. Please refresh the page and try again."
                        }
                        showProblemText={timeCodesError}
                      >
                        <option value="">Select Time Code</option>
                        {timeCodes.length > 0 &&
                          timeCodes.map((timeCode) => {
                            return (
                              <option key={timeCode} value={timeCode}>
                                {timeCode +
                                  " (" +
                                  getTimeCodeMeaning(timeCode) +
                                  ")"}
                              </option>
                            );
                          })}
                      </DiliTextCP>
                      <div className="col-lg-6">
                        <DiliTextCP
                          label="COD"
                          name="CODType"
                          // loading={CODTypeLoadingRef.current} // switched to blocking loading banner as we also need to get time codes upon customer selection now based on zip code
                          value={orderInfo.CODType}
                          onChange={handleChangeOrderInfo}
                          // disabled={invoices[0].declaredValue <= 0}
                          disabled={clientJWTInfo.ClientId === 22927}
                          type="select"
                        >
                          {/* *** WHERE THERE ANY OTHER OPTIONS? DOUBLE CHECK */}
                          {/* <option value="None">None</option> why is there a check on the backend that doesn't work to see if it is NONE? in the dto */}
                          {/* regardless, needs to be null or emptry string to be a none cod order */}
                          <option value={codOptions.None.value}>
                            {codOptions.None.display}
                          </option>
                          <option value={codOptions.COD.value}>
                            {codOptions.COD.display}
                          </option>
                          <option value={codOptions.CertifiedFunds.value}>
                            {codOptions.CertifiedFunds.display}
                          </option>
                        </DiliTextCP>

                        <small
                          className="form-text text-note pl-1"
                          style={{ display: "flex" }}
                        >
                          <input
                            type="checkbox"
                            style={{ marginRight: "5px" }}
                            onChange={handleChangeOrderInfo}
                            checked={orderInfo.isDefaultChecked}
                            disabled={clientJWTInfo.ClientId === 22927}
                            // value={orderInfo.isDefaultChecked}
                            name="isDefaultChecked"
                          />

                          <div
                            style={{
                              // lineHeight: "152px",
                              display: "inline-block",
                            }}
                          >
                            Set as default for this customer.
                          </div>
                        </small>
                      </div>
                    </div>
                    {/* previously had the piecesinput row as a form-row to have them spaced closer together. but this seems more consistent */}
                    <div className="row">
                      <PiecesInput
                        pieceAmount={orderInfo.pieceAmount}
                        pieceType={orderInfo.pieceType}
                        weight={orderInfo.weight}
                        isWeightClient={clientJWTInfo.WeightClient}
                        onChangeOrderInfo={handleChangeOrderInfo}
                        wasSubmitted={submitPressed}
                        successfulSubmissionNotif={
                          wasSubmittedSuccessfullyNotification
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row justify-content-end">
                      <div className="form-group col-xl-8">
                        <label>Reference Number</label>
                        <input
                          name="referenceNumber"
                          value={orderInfo.referenceNumber}
                          onChange={handleChangeOrderInfo}
                          maxLength="20"
                          className="form-control"
                        />
                      </div>
                      {!isModifyingExistingOrder && (
                        <DiliTextCP
                          className="form-group col-xl-8"
                          name="BOLNumber"
                          label="BOL Number"
                          minLength="1"
                          maxLength="25" // might want to confirm what it is on CXT's side
                          value={orderInfo.BOLNumber}
                          onChange={handleChangeOrderInfo}
                          wasSubmitted={submitPressed}
                          successfulSubmissionNotif={
                            wasSubmittedSuccessfullyNotification
                          }
                        />
                      )}
                      <div className="form-group col-xl-8">
                        <label>Comments</label>
                        <textarea
                          name="comments"
                          value={orderInfo.comments}
                          onChange={handleChangeOrderInfo}
                          maxLength="500"
                          className="form-control textarea-comments"
                        />
                        <div className="textarea-charactercount">
                          {orderInfo.comments.length}/500
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row sub-panel-header align-items-center">
                  <div className="col-9 col-md-6">
                    Invoices and Insurance Coverage{" "}
                    <TooltipInfoHover tooltipClass="popover-wide">
                      You may add up to {maxInvoices} Invoices and purchase
                      additional insurance coverage for each (
                      {clientJWTInfo.MinimumValuationAmount}$ covered without
                      additional purchase).
                      <br />
                      Max Coverage per Invoice:{" "}
                      {numberFormatter.format(
                        clientJWTInfo.MaximumValuationAmount,
                      )}{" "}
                      USD
                      <br />
                      Insurance Fee: {clientJWTInfo.ValuationRate}%
                      <br />
                      Min Fee: $2.50
                    </TooltipInfoHover>
                  </div>
                  <div className="col-3 col-md-6 col-xl-3">
                    <select
                      name="invoiceAmount"
                      style={{ width: "fit-content" }}
                      className="form-control ml-md-auto"
                      value={invoices.length}
                      onChange={handleChangeNumberOfInvoices}
                    >
                      {(() => {
                        let options = [];
                        for (let i = 0; i < maxInvoices; i++) {
                          options.push(
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>,
                          );
                        }
                        return options;
                      })()}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-9 my-4">
                    <div className="card-list p-2">
                      {invoices.map((invoice, index) => {
                        return (
                          <InvoiceCard
                            key={"card-list-card-" + index} // not exactly unique, basically just the index, might cause issues, look into how we can give these unique keys but right now i don't see how we would because each card starts off blank, other than a random number.
                            index={index}
                            isCodOrCertified={
                              orderInfo.CODType === "COD" ||
                              orderInfo.CODType === "CertifiedFunds"
                            }
                            COD={orderInfo.CODType === "COD"}
                            CertifiedFunds={
                              orderInfo.CODType === "CertifiedFunds"
                            }
                            wasSubmitted={submitPressed}
                            successfulSubmissionNotif={
                              wasSubmittedSuccessfullyNotification
                            }
                            maximumValuationAmount={
                              clientJWTInfo.MaximumValuationAmount
                            }
                            minimumValuationAmount={
                              clientJWTInfo.MinimumValuationAmount
                            }
                            valuationRate={clientJWTInfo.ValuationRate / 100}
                            invoiceNumber={invoice.invoiceNumber}
                            handleChangeInvoiceNumber={(e) => {
                              handleChangeInvoiceNumber(e, index);
                            }}
                            handleInvoiceNumberKeyUp={handleInvoiceNumberKeyUp}
                            handleFinishEnteringInvoiceNumber={(e) => {
                              handleFinishEnteringInvoiceNumber(e, index);
                            }}
                            isPurchasingInsurance={
                              invoice.wantsValuationCoverage
                            }
                            handleToggleIsPurchasingInsurance={(e) => {
                              handleToggleIsPurchasingInsurance(e, index);
                            }}
                            declaredValue={invoice.invoiceAmount}
                            handleChangeDeclaredValue={(e) => {
                              handleChangeDeclaredValue(e, index);
                            }}
                            deleteInvoice={() => {
                              showDeleteInvoiceModal(index);
                            }}
                            currentInvoiceNumbers={currentInvoiceNumbers}
                          />
                        );
                      })}

                      {invoices.length < maxInvoices && (
                        <div className="card-list-add-container">
                          <div
                            className="card-list-add btn-primary"
                            onClick={addInvoice}
                          >
                            <span className="card-list-add-plus">+</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <p>
                By submitting your order, you agree to our{" "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer" //might not be necessary unless linking to a different site or in modern browsers. not 100% sure, need to research
                  to={constantsJS.pdfLinks.termsAndConditions}
                >
                  terms and conditions
                </Link>
                .
              </p>

              <button className="btn btn-primary">Submit</button>
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default PostOrderFormRework13CityDropdown;
